import * as types from '../../actions/actionTypes';

const defaultState = {
  data: [],
  selected: null,
  imageUploadedUrl: '',
  winnerWithdrewBtn: false,
  isLoadingBounty: true,
  requestJudges: null,
  requestJudgesMess: '',
  fileUploadedUrl: '',
  uploaded: null,
  uploading: false,

  uploadingPresentation: false,
  fileUploadedPresentationUrl: '',
  uploadedPresentation: null,

  uploadingDemo: false,
  fileUploadedDemoUrl: '',
  uploadedDemo: null,

  submitCode: null,
  submitingCodeHackathon: null,
  bountySubmission: null,
  teamSelected: null,

  joinedBounty: null,

  submittedArticle: null, // variable to check submitted Article in bounty  theme challenge

  bountyUser: null,

  bidLoading: false,
  biddedMentor: {},
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    //get bounty
    case types.FETCH_BOUNTY_SUCCESS:
      return { ...state, data: action.data };
    //get bounty detail
    case types.FETCH_BOUNTY_DETAIL:
      return { ...state, selected: null, isLoadingBounty: true };
    case types.FETCH_BOUNTY_DETAIL_SUCCESS:
      return { ...state, selected: action.data, isLoadingBounty: false };
    case types.FETCH_BOUNTY_DETAIL_FAILED:
      return { ...state, selected: null, isLoadingBounty: false };
    //upload image sponsor
    case types.UPLOAD_SPONSOR_IMAGE_SUCCESS:
      return { ...state, imageUploadedUrl: action.data };
    //upload file when join bounty
    case types.UPLOAD_JOIN_BOUNTY_FILE:
      return { ...state, uploading: true };
    case types.UPLOAD_JOIN_BOUNTY_FILE_SUCCESS:
      return { ...state, fileUploadedUrl: action.data, uploaded: true, uploading: false };
    case types.UPLOAD_JOIN_BOUNTY_FILE_FAILED:
      return { ...state, uploaded: false, uploading: false };
    //update winner
    case types.UPDATE_WINNER_WITHDRAW_SUCCESS:
      return { ...state, winnerWithdrewBtn: true };
    //request judges
    case types.REQUEST_JUDGES_DONE:
      return { ...state, requestJudges: action.data };
    case types.REQUEST_JUDGES_FAIL:
      return { ...state, requestJudgesMess: action.reason };
    //upload slide file when submit code
    case types.UPLOAD_PRESENTATION_FILE:
      return { ...state, uploadingPresentation: true };
    case types.UPLOAD_PRESENTATION_FILE_SUCCESS:
      return {
        ...state,
        fileUploadedPresentationUrl: action.data,
        uploadedPresentation: true,
        uploadingPresentation: false,
      };
    case types.UPLOAD_PRESENTATION_FILE_FAILED:
      return { ...state, uploadedPresentation: false, uploadingPresentation: false };
    //upload demo file when submit code
    case types.UPLOAD_DEMO_FILE:
      return { ...state, uploadingDemo: true };
    case types.UPLOAD_DEMO_FILE_SUCCESS:
      return { ...state, fileUploadedDemoUrl: action.data, uploadedDemo: true, uploadingDemo: false };
    case types.UPLOAD_DEMO_FILE_FAILED:
      return { ...state, uploadedDemo: false, uploadingDemo: false };
    //submit code hackathon
    case types.SUBMIT_CODE_HACKATHON:
      return { ...state, submitCode: false, submitingCodeHackathon: true };
    case types.SUBMIT_CODE_HACKATHON_SUCCESS:
      return { ...state, submitCode: true, submitingCodeHackathon: false };
    case types.SUBMIT_CODE_HACKATHON_FAIL:
      return { ...state, submitCode: false, submitingCodeHackathon: false };
    //get bounty submission
    case types.GET_BOUNTY_SUBMISSION:
      return { ...state, bountySubmission: null, loadingSubmission: true };
    case types.GET_BOUNTY_SUBMISSION_SUCCESS:
      return { ...state, bountySubmission: action.payload, loadingSubmission: false };

    // join bounty theme challenge
    case types.JOIN_BOUNTY_CHALLENGE:
      return { ...state, joinedBounty: false };
    case types.JOIN_BOUNTY_CHALLENGE_SUCCESS:
      return { ...state, joinedBounty: true };
    case types.JOIN_BOUNTY_CHALLENGE_FAILED:
      return { ...state, joinedBounty: false };

    // submitted article with theme challenge
    case types.MARKED_SUBMIT_ARTICLE:
      return { ...state, submittedArticle: false };
    case types.MARKED_SUBMIT_ARTICLE_SUCCESS:
      return { ...state, submittedArticle: true };
    case types.MARKED_SUBMIT_ARTICLE_FAILED:
      return { ...state, submittedArticle: false };

    case types.GET_BOUNTY_USER_SUCCESS:
      return { ...state, bountyUser: action.data };

    case types.BID_MENTOR:
      return { ...state, bidLoading: true };
    case types.BID_MENTOR_SUCCESS:
      return { ...state, biddedMentor: action.data, bidLoading: false };
    case types.BID_MENTOR_FAILED:
      return { ...state, bidLoading: false };

    case types.GET_BID_MENTOR_SUCCESS:
      return { ...state, biddedMentor: action.data };

    case types.UPDATE_CHALLENGE_OF_TEAM_SUCCESS: {
      const { teamId, challenge } = action.payload;
      console.log('State:', state);
      const updatedTeams = state.selected?.teams?.map((item) => (item._id === teamId ? { ...item, challenge } : item));
      return {
        ...state,
        selected: {
          ...state.selected,
          teams: updatedTeams,
        },
      };
    }

    default:
      return nextState;
  }
};
